import { render } from "./VuexSelectSearchItem.vue?vue&type=template&id=df324588"
import script from "./VuexSelectSearchItem.vue?vue&type=script&lang=js"
export * from "./VuexSelectSearchItem.vue?vue&type=script&lang=js"
script.render = render

export default script